import { Helmet } from "react-helmet-async";

const SITE = "https://discover-cancun.com";
const DEFAULT_OG = `${SITE}/logo-cropped.png`;

const SEO = ({
  title,
  description,
  path = "",
  image,
  type = "website",
  publishedTime,
  modifiedTime,
  keywords,
  lang = "en",
  noindex = false,
}) => {
  if (!title) return null;
  const fullTitle = String(title).includes("Discover Cancun")
    ? title
    : `${title} | Discover Cancun`;
  const url = `${SITE}${path}`;
  const ogImage = image || DEFAULT_OG;
  const robots = noindex
    ? "noindex,nofollow"
    : "index,follow,max-image-preview:large,max-snippet:-1";

  const meta = [
    { name: "description", content: description || "" },
    { name: "robots", content: robots },
    { property: "og:type", content: type },
    { property: "og:url", content: url },
    { property: "og:title", content: fullTitle },
    { property: "og:description", content: description || "" },
    { property: "og:image", content: ogImage },
    { property: "og:site_name", content: "Discover Cancun" },
    { property: "og:locale", content: lang === "es" ? "es_MX" : "en_US" },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: fullTitle },
    { name: "twitter:description", content: description || "" },
    { name: "twitter:image", content: ogImage },
  ];
  if (keywords) meta.push({ name: "keywords", content: keywords });
  if (publishedTime)
    meta.push({ property: "article:published_time", content: publishedTime });
  if (modifiedTime)
    meta.push({ property: "article:modified_time", content: modifiedTime });

  return (
    <Helmet
      title={fullTitle}
      htmlAttributes={{ lang }}
      meta={meta}
      link={[{ rel: "canonical", href: url }]}
    />
  );
};

export default SEO;
